import io from 'socket.io-client';

import messagesApi from './messages';
import { paramsToObject, storageCreator } from '../utils';

export const VISITOR_COOKIE_NAME = process.env.REACT_APP_VISITOR_COOKIE_NAME;

export const API_URL = process.env.REACT_APP_API_URL;
export const userStatisticEnv = process.env.REACT_APP_COLLECT_USER_STATISTIC;

const visitorCookieExpireDate = new Date();
visitorCookieExpireDate.setFullYear(visitorCookieExpireDate.getFullYear() + 1);

export const VISITOR_COOKIE_PARAMS = {
  NAME: VISITOR_COOKIE_NAME,
  EXPIRE: visitorCookieExpireDate,
  PATH: '/',
  DOMAIN: null,
  SECURE: true,
  SAMESITE: 'None',
};

const urlParams = new URLSearchParams(window.location.search);
const urlParamsObj = paramsToObject(urlParams);

const CURRENT_DIALOG_ID_KEY = 'currentDialogId';

let hasAuthenticatedOnce = false;
let socketResync = null;
let resyncTimer = null;
let reconnectTimer = null;

export const registerSocketResync = (fn) => {
  socketResync = fn;
};

const getDialogIdForResync = () => {
  const sessionStore = storageCreator(() => sessionStorage);
  const localStore = storageCreator(() => localStorage);
  return sessionStore.getItem(CURRENT_DIALOG_ID_KEY) || localStore.getItem('dialogId');
};

const resyncMessages = () => {
  clearTimeout(resyncTimer);
  resyncTimer = setTimeout(() => {
    if (!socket.connected) {
      return;
    }

    if (socketResync) {
      socketResync();
      return;
    }

    const dialogId = getDialogIdForResync();
    if (dialogId) {
      messagesApi.getAllMessages(dialogId);
    }
  }, 300);
};

const reconnectAfterWake = () => {
  if (document.hidden) {
    return;
  }

  clearTimeout(reconnectTimer);
  reconnectTimer = setTimeout(() => {
    if (socket.connected) {
      socket.disconnect();
    }
    socket.connect();
  }, 100);
};

export const socket = io.connect(API_URL, {
  autoConnect: false,
  reconnection: true,
  reconnectionDelayMax: 2000,
  reconnectionDelay: 1000,
  timeout: 2000,
  reconnectionAttempts: 2000,
  withCredentials: true,
  transports: ['websocket', 'polling'],
});

const isEmex = window.location.href.includes('/emex');

if (socket.io && socket.io.opts) {
  socket.io.opts.query = { ...socket.io.opts.query, ...urlParamsObj };
  if (isEmex) {
    socket.io.opts.query.emex = true;
  }
}

socket.on('connect', () => {
  window.history.replaceState(window.location.host, '', window.location.pathname);
});

socket.on('buyer.auth', () => {
  if (hasAuthenticatedOnce) {
    resyncMessages();
  }
  hasAuthenticatedOnce = true;
});

document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    reconnectAfterWake();
  }
});

window.addEventListener('pageshow', () => {
  if (!document.hidden) {
    reconnectAfterWake();
  }
});

window.addEventListener('online', () => {
  reconnectAfterWake();
});

window.addEventListener('offline', () => {
  if (socket.connected) {
    socket.disconnect();
  }
});
